import { Store } from 'utils';

class SuperfairStore extends Store {

	getInitialState() {
		return {
			id: null,
			name: null,
			fairs: []
		}
	}

	onFairsChanged(state, data) {
        state.fairs = data.fairs;
    }

	getFairs() {
		return this.getState().fairs;
	}
}

const store = new SuperfairStore();
export default store;


// WEBPACK FOOTER //
// ./src/modules/model/superfairstore.js